export const IMG_DEFAULT = `https://whatsapp.sac.digital/_midia/semimagem.jpg`;